import { render, staticRenderFns } from "./SecretData.vue?vue&type=template&id=48178ed6&"
import script from "./SecretData.vue?vue&type=script&lang=js&"
export * from "./SecretData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports